<script>
  import { boolean } from '@st-graphics/graphics-kit/utils'
  import { Headline, ScrollDownMessage } from '@st-graphics/graphics-components'
  import Intro from '$components/Project/Intro/Intro.svelte'
  let {
    navbar,
    byline,
    datetime,
    modifieddatetime,
    deck,
    headline,
    menuitems,
    classname,
    mobiledeck = 'true',
    cards = [],
    headlineposition = 'after',
    balancehed = true,
    balancedek = true,
  } = $props()

  $inspect(headline)
</script>

<div class="nav" class:gradient={headlineposition !== 'start'}>
  {@render navbar?.()}
</div>

<div class={`article-head scrolly ${classname} ${headlineposition}`}>
  <div class="main-headline-head-wrapper {headlineposition}">
    <div class="article-hero" style="--article-head-hero-max-width: 100%;">
      <Intro {cards} {headlineposition}>
        {#snippet headercard()}
          <!--<Headline
            hed={headline}
            dek={deck}
            {byline}
            {datetime}
            {modifieddatetime}
            mobiledeck={boolean(mobiledeck)}
            balancehed={boolean(balancehed)}
            balancedek={boolean(balancedek)}
          />-->
        {/snippet}
      </Intro>

      <!--{#if headlineposition === 'after'}-->
      <div class="article-headline {headlineposition}">
        <Headline
          hed={headline}
          dek={deck}
          {byline}
          {datetime}
          {modifieddatetime}
          mobiledeck={boolean(mobiledeck)}
          balancehed={boolean(balancehed)}
          balancedek={boolean(balancedek)}
        />
      </div>
      <!--{/if}-->
    </div>
  </div>
</div>

<style lang="scss">
  .nav {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9;
    --navbar-color: var(--st-white);
    --brand-color: currentcolor;

    :global(a),
    :global(.menu) {
      color: #fff !important;
    }

    &.gradient {
      &:before {
        position: absolute;
        left: 0;
        top: 0;
        z-index: -1;
        display: block;
        width: 100%;
        height: 250px;
        content: '';
        background-image: linear-gradient(
          to bottom,
          var(--article-head-hero-overlay-background-color) 0%,
          rgba(0, 0, 0, 0.4) 40%,
          rgba(0, 0, 0, 0.2) 70%,
          transparent 100%
        );
      }
    }
  }
  .article-head {
    --article-head-color: currentcolor;
    --article-head-hero-overlay-background-color: rgb(0 0 0 /70%);
    --headline-hed-color: currentcolor;
    --headline-dek-color: currentcolor;
    --headline-metadata-color: currentcolor;
    --link-color: currentcolor;

    position: relative;
    color: var(--article-head-color);
    text-align: var(--article-head-text-align);
    background: var(--article-head-background);
    background-size: cover;

    &.scrolly {
      :global(.scrolly-step figure) {
        position: absolute;
        min-width: 100%;
        min-height: 100%;
      }

      :global(.scrolly-step img) {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      :global(.header-card.start) {
        background: transparent !important;
        &::before {
          position: absolute;
          left: 0;
          top: 0;
          z-index: -10;
          display: block;
          width: 100%;
          height: 100vh;
          margin-top: -100vh;
          content: '';
          background-image: linear-gradient(
            to bottom,
            var(--article-head-hero-overlay-background-color) 0%,
            rgba(0, 0, 0, 0.4) 40%,
            rgba(0, 0, 0, 0.2) 70%,
            transparent 100%
          );
        }
      }
      :global(.header-card.end) {
        background: transparent !important;
        &::before {
          position: absolute;
          left: 0;
          bottom: 0;
          z-index: -10;
          display: block;
          width: 100%;
          height: 100vh;
          content: '';
          background-image: linear-gradient(
            to top,
            var(--article-head-hero-overlay-background-color) 0%,
            rgba(0, 0, 0, 0.4) 40%,
            rgba(0, 0, 0, 0.2) 70%,
            transparent 100%
          );
        }
      }
    }

    .main-headline-head-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100%;

      .article-headline {
        position: relative;
        top: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-top: 114px; // Scroll message margin-top (50) + height (64)
        z-index: 999;

        &.start,
        &.end {
          --article-head-color: var(--st-white) !important;
          --headline-hed-color: var(--st-white) !important;
          --headline-dek-color: var(--st-white) !important;
          --byline-color: var(--st-white) !important;
          --link-color: var(--st-white) !important;
          --byline-link-color: var(--st-white) !important;
          --link-text-decoration-color: var(--st-white) !important;
          --scroll-down-message-color: var(--st-white) !important;
          :global(.headline) {
            pointer-events: all;
            padding: 0 !important;
          }
        }

        &.after {
          margin-top: 20px;
          padding: 0 15px;
          --link-text-decoration-color: currentcolor;
        }
      }
    }

    :global(.after .headline .wrapper:last-of-type) {
      border-bottom: 1px dotted
        var(--article-head-plain-headline-border-color, var(--st-medium-gray));
    }

    :global(.inline-menu a) {
      color: var(--inline-menu-color, '#fff');
    }
  }
</style>
